import Head from 'next/head';
import Script from 'next/script';

interface Props {
  pageUrl: string;
}

export const TaboolaPixelHeader: React.FC<Props> = ({ pageUrl }) => {
  return (
    <>
      <Head>
        <script id="taboola-pixel">
          {`window._tfa = window._tfa || []; window._tfa.push({notify: 'event', name: 'page_view', id: 1482991});!function (t, f, a, x) { if (!document.getElementById(x)) { t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);} }(document.createElement('script'), document.getElementsByTagName('script')[0], '//cdn.taboola.com/libtrc/unip/1482991/tfa.js', 'tb_tfa_script');`}
        </script>
      </Head>
      <Script id="pixel-benzinga-native-page-view">
        {`
          window._tfa = window._tfa || [];
          _tfa.push({ notify: 'action',name: 'page_view' });
        `}
      </Script>
      <Script id="pixel-benzinga-native" src="//cdn.taboola.com/libtrc/benzinga-native/tfa.js" />
      <img
        height="0"
        src={`//trc.taboola.com/benzinga-native/log/3/action?name=page_view&item-url=${pageUrl}`}
        width="0"
      />
    </>
  );
};
